import { render, staticRenderFns } from "./PayDialog.vue?vue&type=template&id=5dc89d7e&scoped=true"
import script from "./PayDialog.vue?vue&type=script&lang=js"
export * from "./PayDialog.vue?vue&type=script&lang=js"
import style0 from "./PayDialog.vue?vue&type=style&index=0&id=5dc89d7e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dc89d7e",
  null
  
)

export default component.exports